// /**
//  * Collection Load More Functionality for Dawn Theme
//  * Version: 1.0.0
//  * 
//  * This script handles AJAX loading of products on collection pages
//  * without requiring a page refresh.
//  */

// class CollectionLoadMore {
//   constructor() {
//     this.loadMoreButton = document.querySelector('.load-more-button');
//     this.loadMoreContainer = document.querySelector('.load-more-container');
//     this.productGrid = document.querySelector('#product-grid');
    
//     if (!this.loadMoreButton || !this.productGrid) return;
    
//     this.currentPage = parseInt(this.loadMoreContainer.dataset.currentPage);
//     this.totalPages = parseInt(this.loadMoreContainer.dataset.totalPages);
//     this.collectionUrl = this.loadMoreContainer.dataset.collectionUrl;
//     this.isLoading = false;
    
//     this.init();
//   }

//   init() {
//     this.loadMoreButton.addEventListener('click', () => this.loadMore());
    
//     // Optional: Add infinite scroll
//     // Uncomment the following lines to enable infinite scroll
//     // this.setupInfiniteScroll();
//   }

//   async loadMore() {
//     if (this.isLoading) return;
    
//     const nextUrl = this.loadMoreButton.dataset.nextUrl;
//     if (!nextUrl) return;

//     this.setLoadingState(true);

//     try {
//       const response = await fetch(nextUrl);
      
//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }
      
//       const html = await response.text();
//       const parser = new DOMParser();
//       const doc = parser.parseFromString(html, 'text/html');
      
//       // Extract new products
//       const newProducts = doc.querySelectorAll('#product-grid .grid__item');
      
//       if (newProducts.length > 0) {
//         // Append new products with animation
//         newProducts.forEach((product, index) => {
//           const clone = product.cloneNode(true);
//           clone.style.opacity = '0';
//           clone.style.transform = 'translateY(20px)';
//           this.productGrid.appendChild(clone);
          
//           // Animate in
//           setTimeout(() => {
//             clone.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
//             clone.style.opacity = '1';
//             clone.style.transform = 'translateY(0)';
//           }, index * 50);
//         });

//         // Update pagination state
//         this.currentPage++;
//         this.updatePaginationState(doc);
        
//         // Trigger Shopify theme events for product cards (quick view, etc.)
//         if (typeof window.Shopify !== 'undefined' && window.Shopify.ProductForm) {
//           // Re-initialize product forms if needed
//           this.reinitializeProductCards();
//         }
//       }
      
//     } catch (error) {
//       console.error('Error loading more products:', error);
//       this.showError();
//     } finally {
//       this.setLoadingState(false);
//     }
//   }

//   updatePaginationState(doc) {
//     const newLoadMoreContainer = doc.querySelector('.load-more-container');
    
//     if (!newLoadMoreContainer) {
//       // No more pages, hide button
//       this.hideLoadMoreButton();
//       return;
//     }

//     const newButton = newLoadMoreContainer.querySelector('.load-more-button');
    
//     if (newButton && newButton.dataset.nextUrl) {
//       // Update next URL
//       this.loadMoreButton.dataset.nextUrl = newButton.dataset.nextUrl;
//       this.loadMoreContainer.dataset.currentPage = this.currentPage;
//     } else {
//       // No more products to load
//       this.hideLoadMoreButton();
//     }
//   }

//   setLoadingState(loading) {
//     this.isLoading = loading;
//     const buttonText = this.loadMoreButton.querySelector('.load-more-text');
//     const spinner = this.loadMoreButton.querySelector('.load-more-spinner');
    
//     if (loading) {
//       this.loadMoreButton.disabled = true;
//       this.loadMoreButton.classList.add('loading');
//       buttonText.style.display = 'none';
//       spinner.style.display = 'inline-block';
//     } else {
//       this.loadMoreButton.disabled = false;
//       this.loadMoreButton.classList.remove('loading');
//       buttonText.style.display = 'inline';
//       spinner.style.display = 'none';
//     }
//   }

//   hideLoadMoreButton() {
//     this.loadMoreButton.style.transition = 'opacity 0.3s ease';
//     this.loadMoreButton.style.opacity = '0';
    
//     setTimeout(() => {
//       this.loadMoreContainer.style.display = 'none';
//       this.showEndMessage();
//     }, 300);
//   }

//   showEndMessage() {
//     const message = document.createElement('div');
//     message.className = 'load-more-end-message';
//     message.textContent = 'You\'ve viewed all products';
//     message.style.opacity = '0';
    
//     this.loadMoreContainer.appendChild(message);
    
//     setTimeout(() => {
//       message.style.transition = 'opacity 0.3s ease';
//       message.style.opacity = '1';
//     }, 100);
//   }

//   showError() {
//     const errorMessage = document.createElement('div');
//     errorMessage.className = 'load-more-error';
//     errorMessage.innerHTML = `
//       <p>Unable to load more products. Please try again.</p>
//       <button type="button" class="button button--secondary" onclick="location.reload()">
//         Refresh Page
//       </button>
//     `;
    
//     this.loadMoreContainer.appendChild(errorMessage);
//     this.loadMoreButton.style.display = 'none';
//   }

//   reinitializeProductCards() {
//     // Re-run any theme-specific JavaScript for new product cards
//     // This is theme-dependent, adjust as needed
    
//     // Example: Reinitialize quick view buttons
//     const quickViewButtons = this.productGrid.querySelectorAll('.quick-add-button');
//     quickViewButtons.forEach(button => {
//       if (!button.hasAttribute('data-initialized')) {
//         // Your quick view initialization code here
//         button.setAttribute('data-initialized', 'true');
//       }
//     });

//     // Example: Reinitialize product media
//     if (window.theme && window.theme.initProductMedia) {
//       window.theme.initProductMedia();
//     }
//   }

//   // Optional: Infinite Scroll Implementation
//   setupInfiniteScroll() {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach(entry => {
//           if (entry.isIntersecting && !this.isLoading && this.currentPage < this.totalPages) {
//             this.loadMore();
//           }
//         });
//       },
//       {
//         rootMargin: '200px'
//       }
//     );

//     observer.observe(this.loadMoreButton);
//   }
// }

// // Initialize when DOM is ready
// if (document.readyState === 'loading') {
//   document.addEventListener('DOMContentLoaded', () => {
//     new CollectionLoadMore();
//   });
// } else {
//   new CollectionLoadMore();
// }

// // Re-initialize on Shopify section rendering (theme editor)
// document.addEventListener('shopify:section:load', () => {
//   new CollectionLoadMore();
// });


"use strict";
var Ajaxinate = function(config) {
    var settings = config || {}
      , defaultSettings = {
        pagination: ".AjaxinatePagination",
        method: "scroll",
        container: ".AjaxinateLoop",
        offset: 0,
        loadingText: "Load More",
        callback: null
    };
    this.settings = Object.assign(defaultSettings, settings),
    this.addScrollListeners = this.addScrollListeners.bind(this),
    this.addClickListener = this.addClickListener.bind(this),
    this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this),
    this.stopMultipleClicks = this.stopMultipleClicks.bind(this),
    this.destroy = this.destroy.bind(this),
    this.containerElement = document.querySelector(this.settings.container),
    this.paginationElement = document.querySelector(this.settings.pagination),
    this.initialize()
};
Ajaxinate.prototype.initialize = function() {
    if (this.containerElement) {
        var initializers = {
            click: this.addClickListener,
            scroll: this.addScrollListeners
        };
        initializers[this.settings.method]()
    }
}
,
Ajaxinate.prototype.addScrollListeners = function() {
    this.paginationElement && (document.addEventListener("scroll", this.checkIfPaginationInView),
    window.addEventListener("resize", this.checkIfPaginationInView),
    window.addEventListener("orientationchange", this.checkIfPaginationInView))
}
,
Ajaxinate.prototype.addClickListener = function() {
    this.paginationElement && (this.nextPageLinkElement = this.paginationElement.querySelector("a"),
    this.clickActive = !0,
    this.nextPageLinkElement !== null && this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks))
}
,
Ajaxinate.prototype.stopMultipleClicks = function(event) {
    event.preventDefault(),
    this.clickActive && (this.nextPageLinkElement.innerHTML = this.settings.loadingText,
    this.nextPageUrl = this.nextPageLinkElement.href,
    this.clickActive = !1,
    this.loadMore())
}
,
Ajaxinate.prototype.checkIfPaginationInView = function() {
    var top = this.paginationElement.getBoundingClientRect().top - this.settings.offset
      , bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
    top <= window.innerHeight && bottom >= 0 && (this.nextPageLinkElement = this.paginationElement.querySelector("a"),
    this.removeScrollListener(),
    this.nextPageLinkElement && (this.nextPageLinkElement.innerHTML = this.settings.loadingText,
    this.nextPageUrl = this.nextPageLinkElement.href,
    this.loadMore()))
}
,
Ajaxinate.prototype.loadMore = function() {
    this.request = new XMLHttpRequest,
    this.request.onreadystatechange = function() {
        if (this.request.readyState === 4 && this.request.status === 200) {
            var newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0]
              , newPagination = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];
            this.containerElement.insertAdjacentHTML("beforeend", newContainer.innerHTML),
            this.paginationElement.innerHTML = newPagination.innerHTML,
            this.settings.callback && typeof this.settings.callback == "function" && this.settings.callback(this.request.responseXML),
            this.initialize()
        }
    }
    .bind(this),
    this.request.open("GET", this.nextPageUrl),
    this.request.responseType = "document",
    this.request.send()
}
,
Ajaxinate.prototype.removeClickListener = function() {
    this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks)
}
,
Ajaxinate.prototype.removeScrollListener = function() {
    document.removeEventListener("scroll", this.checkIfPaginationInView),
    window.removeEventListener("resize", this.checkIfPaginationInView),
    window.removeEventListener("orientationchange", this.checkIfPaginationInView)
}
,
Ajaxinate.prototype.destroy = function() {
    var destroyers = {
        click: this.removeClickListener,
        scroll: this.removeScrollListener
    };
    return destroyers[this.settings.method](),
    this
}
;
//# sourceMappingURL=/cdn/shop/t/3/assets/collection-load-more.js.map?v=133846471585431443491773233388
